import { connect } from 'react-redux';

import { STATUSES } from 'legacy/appstore/constants';

import {
  getIsDownloadingPdf,
  getIsDownloadingExcel
} from 'selectors/download-report';
import {
  getReportStatusIsRecomputing,
  getReportStatusSaveInProgress,
  getReportStatusCompsIsLoaded,
  getReportStatusSharedReportConfigDoesNotExist
} from 'selectors/report-status';
import { getShowShareDropDown } from 'selectors/app-header';
import { getReportActiveStatus } from 'selectors/report-data';
import { getRentalReportStatus } from 'selectors/rental-report';
import { getSubjectLocationUnknown } from 'selectors/subject';
import { getIsExcelDownloadAllowed } from 'selectors/report-permissions';

import { downloadReport } from 'actions/download-report';

import DownloadReportButton from 'legacy/components/DownloadReportButton';

const mapStateToProps = (state) => {
  let reportStatus = getReportActiveStatus(state);
  // TODO: remove this once status is populated properly in the API response
  if (!reportStatus) {
    reportStatus = 'active';
  }
  const rentalReportStatus = getRentalReportStatus(state);
  return {
    disableControls:
      !getReportStatusCompsIsLoaded(state) ||
      getReportStatusIsRecomputing(state) ||
      getReportStatusSaveInProgress(state) ||
      rentalReportStatus === STATUSES.INIT ||
      rentalReportStatus === STATUSES.LOADING,
    isDownloadingXLS: getIsDownloadingExcel(state),
    isDownloadingPDF: getIsDownloadingPdf(state),
    uniqueLinkDoesNotExist:
      getReportStatusSharedReportConfigDoesNotExist(state),
    showShareDropdown: getShowShareDropDown(state),
    locationUnknown: getSubjectLocationUnknown(state),
    isExcelDownloadAllowed: getIsExcelDownloadAllowed(state)
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleClickExcel: () => {
    dispatch(downloadReport('xlsx'));
  },
  handleClickPdf: () => {
    dispatch(downloadReport('pdf'));
  },
  handleClickPrint: () => {
    // Allow actions that depend on scroll position to take place before triggering print dialog
    window.setTimeout(() => {
      window.print();
    }, 1);
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DownloadReportButton);
